import * as React from 'react';
import './PageSubheading.css';
import H from '../../H/H';
import I18n from '../../I18n/I18n/I18n';
function PageSubheading(_ref) {
  var i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement(H, {
    className: "page-subheading"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  }));
}
PageSubheading.displayName = 'PageSubheading';
export default PageSubheading;